module.exports = __webpack_public_path__ + "static/media/success@3x.ef6cd2b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/icons/success@3x.png
// module id = 622
// module chunks = 0